import styled from 'styled-components';
import { container, flexPosition, fontStyle } from '../../styles/mixins';
import {
  BORDER_RADIUS,
  MAIN_COLOR,
  GRAY_MEDIUM,
  FONT_SIZE_6,
  FONT_WEIGHT_BOLD,
  GRAY_DARKER,
  DANGER_COLOR,
  WHITE,
} from '../../styles/variables';

export const Container = styled.div`
  height: 85px;
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: ${WHITE};
  box-shadow: 0px 0px 10px -1px rgba(0, 0, 0, 0.1);
`;

export const Content = styled.div`
  ${container()}
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  height: 100%;
`;

export const ContinueButton = styled.button`
  background-color: ${MAIN_COLOR};
  border: none;
  width: 160px;
  height: 45px;
  border-radius: ${BORDER_RADIUS};
  ${fontStyle(WHITE, FONT_SIZE_6, FONT_WEIGHT_BOLD)}
`;

export const CancelButton = styled.button`
  width: 100px;
  height: 45px;
  border: 1px solid ${GRAY_MEDIUM};
  border-radius: ${BORDER_RADIUS};
  background-color: transparent;
  ${fontStyle(GRAY_DARKER, FONT_SIZE_6, FONT_WEIGHT_BOLD)}
`;

export const ErrorContainer = styled.div`
  height: 65px;
  width: 400px;
  background-color: ${DANGER_COLOR};
  border-radius: ${BORDER_RADIUS};
  padding: 5px 10px;
  ${flexPosition({ align: 'center' })}
`;

export const WarningIcon = styled.img`
  width: 40px;
  margin-right: 10px;
`;

export const Message = styled.p`
  ${fontStyle(WHITE, FONT_SIZE_6, FONT_WEIGHT_BOLD)}
  margin: 0;
`;



// WEBPACK FOOTER //
// ./src/components/FormFooter/style.js